<template>
<div class="app" id="app">
  <!-- <layout></layout> -->
  <router-view class="router"></router-view>
</div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    theme () {
      return (this.$store.getters.company && this.$store.getters.company.companySkin) ? this.$store.getters.company.companySkin : null
    }
  },
  methods: {
    changeTheme (themeName) {
      if (themeName) {
        const htmlElement = document.getElementsByTagName('html')[0]
        htmlElement.className = 'theme-' + themeName
      }
    }
  },
  watch: {
    theme (val) {
      this.changeTheme(val)
    }
  },
  created () {
    this.changeTheme(this.theme)
  }
}
</script>

<style lang="less">
@import 'style/base/reset.less';
@import 'style/base/base.less';
.router{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue